import { render, staticRenderFns } from "./Ruleta2.vue?vue&type=template&id=a7fc5baa&"
import script from "./Ruleta2.vue?vue&type=script&lang=js&"
export * from "./Ruleta2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports